"use strict";

angular.module("preventUnsavedChanges")
.controller("UnsavedChangesModalController", function($scope, $attrs, close) {
    this.message = $attrs.message;

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if (confirm) {
            close.apply(this, arguments);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/prevent-unsaved-changes/prevent-unsaved-changes.modal.js
// module id = 341
// module chunks = 0